"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BugMovementSystem = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
class BugMovementSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.BUG_MOVEMENT_AND_ANIMATION);
        this.bugs = [];
    }
    onClear() {
    }
    onLocalMessage(message) {
    }
    onPeerMessage(peerId, message) {
    }
    onServerMessage(message) {
    }
    onEntityAddedComponent(entity, component) {
        this.bugs.push(component);
    }
    onEntityRemovedComponent(entity, component) {
        this.bugs = this.bugs.filter(b => b !== component);
    }
    update(delta) {
        this.bugs.forEach((movementComponent) => {
            movementComponent.updateMovement(delta);
        });
    }
}
exports.BugMovementSystem = BugMovementSystem;
//# sourceMappingURL=module.js.map